let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1h1RF")).then(() => parcelRequire('84L5r'));